// extracted by mini-css-extract-plugin
export default {"Container":"ScrollableTable-module__Container__cu5C2","Table":"ScrollableTable-module__Table__MNkQv"};